'use strict';
import React from 'react';
import classNames from 'classnames';

import Button from './button';
import Icon from 'components/clarity-ui/components/icon'

/**
 * IconButton component
 * IconButton can be applied to both buttons and anchors. Any icon can be used inside a button or link.
 * IconButtons can be disabled by setting the disabled attribute.
 * The browser must be prevented from handling the click event since links do not support the disabled attribute.
 *
 * Usage:
 *
 * ```Javascript
 * <IconButton iconClass="">
 * </IconButton>
 * ```
 *
 * @extends {Button}
 * @property {Boolean} disabled Renders the IconButton as disabled.
 * @property {String} iconClass Sets the icon image that will be used on the IconButton
 * @property {String} name Sets the name attribute of the IconButton.
 * @property {Function} onClick Callback on value change.
 */
class IconButton extends Button {

  /**
   * @return {PropType} Component Children.
   */
  getChildren () {
    return <Icon className="IconButton-icon" iconClass={this.props.iconClass} />;
  }

  /**
   * @return {String} Component CSS classname.
   */
  getClassName () {
    return classNames({
      'IconButton': true,
      [`${this.props.additionalClassName}`]: !!this.props.additionalClassName,
      'is-disabled': this.props.disabled
    });
  }

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    return super.render();
  }
}

/**
 * @prop {propTypes} propTypes attributes for the IconButton component
 */
IconButton.propTypes = {
  iconClass: React.PropTypes.string.isRequired,
  onClick: React.PropTypes.func.isRequired
};

IconButton.defaultProps = {
  elementType: 'button'
}

export default IconButton;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/inputs/iconButton.jsx